import { ReactElement } from 'react';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import Unit from './Unit';
import HorizontalLine from '@src/sld/components/Line/HorizontalLine';
import { UnitController, UnitControllerSN } from '../devicePointsConfig';
import { getDataPointsForUnitController } from '@src/sld/utils';

type A_UnitsProps = {
  unitControllersWithDataPointValues: UnitController[];
};

function A_Units(props: A_UnitsProps): ReactElement {
  const { unitControllersWithDataPointValues } = props;

  return (
    <>
      <HorizontalLine
        translateXCoordinate={330}
        translateYCoordinate={175}
        length={485}
        color='white'
        width={0.5}
      />

      <VerticalLine
        translateXCoordinate={815}
        translateYCoordinate={0}
        length={175}
        color='white'
        width={0.5}
      />

      <VerticalLine
        translateXCoordinate={330}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A1'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_A1,
        )}
        rectangleXCoordinate='295'
        rectangleYCoordinate='200'
        textStartingXCoordinate={300}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={390}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A2'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_A2,
        )}
        rectangleXCoordinate='360'
        rectangleYCoordinate='200'
        textStartingXCoordinate={365}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={455}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A3'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_A3,
        )}
        rectangleXCoordinate='425'
        rectangleYCoordinate='200'
        textStartingXCoordinate={430}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={520}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />

      <Unit
        label={'F1A4'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_A4,
        )}
        rectangleXCoordinate='490'
        rectangleYCoordinate='200'
        textStartingXCoordinate={495}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={580}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A5'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_A5,
        )}
        rectangleXCoordinate='555'
        rectangleYCoordinate='200'
        textStartingXCoordinate={560}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={650}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A6'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_A6,
        )}
        rectangleXCoordinate='620'
        rectangleYCoordinate='200'
        textStartingXCoordinate={625}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={710}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A7'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_A7,
        )}
        rectangleXCoordinate='685'
        rectangleYCoordinate='200'
        textStartingXCoordinate={690}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />

      <VerticalLine
        translateXCoordinate={775}
        translateYCoordinate={175}
        length={25}
        color='white'
        width={0.5}
      />
      <Unit
        label={'F1A8'}
        dataPoints={getDataPointsForUnitController(
          unitControllersWithDataPointValues,
          UnitControllerSN.F2_A8,
        )}
        rectangleXCoordinate='750'
        rectangleYCoordinate='200'
        textStartingXCoordinate={755}
        textStartingYCoordinate={198}
        lineTransformXCoordinate={235}
        lineTransformYCoordinate={175}
        skipHorizontalLine
      />
    </>
  );
}

export default A_Units;
